import React, { memo } from 'react'

import { BaseText, BaseView } from '@/components/base'
import { Checkbox } from '@/components/Checkbox'
import { kemCardTermsChecklist } from '../../constants'

interface KemCardTermsCheckboxGroupProps {
  acceptedTerms: boolean[]
  setAcceptedTerms: (terms: boolean[]) => void
}

export const KemCardTermsCheckboxGroup = memo<KemCardTermsCheckboxGroupProps>(
  ({ acceptedTerms, setAcceptedTerms }) => {
    const handleToggle = (index: number) => {
      const updated = [...acceptedTerms]
      updated[index] = !updated[index]
      setAcceptedTerms(updated)
    }

    return (
      <BaseView gap={12}>
        {kemCardTermsChecklist.map((term, index) => (
          <BaseView key={term.id} gap={12} row>
            <Checkbox
              checked={acceptedTerms[index]}
              onChange={() => handleToggle(index)}
              size={20}
            />

            <BaseView flex={1}>
              <BaseText fontSize={14} style={{ lineHeight: '20px' }}>
                {term.label}
                {term.link1 && (
                  <BaseText
                    fontSize={14}
                    style={{
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      color: 'inherit',
                    }}
                    onClick={term.onPressLink1}
                  >
                    {' '}
                    {term.link1}
                  </BaseText>
                )}
                {term.afterLink1 && <> {term.afterLink1} </>}
                {term.link2 && (
                  <BaseText
                    fontSize={14}
                    style={{
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      color: 'inherit',
                    }}
                    onClick={term.onPressLink2}
                  >
                    {term.link2}
                  </BaseText>
                )}
                {term.afterLink2 && <> {term.afterLink2} </>}
                {term.link3 && (
                  <BaseText
                    fontSize={14}
                    style={{
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      color: 'inherit',
                    }}
                    onClick={term.onPressLink3}
                  >
                    {term.link3}
                  </BaseText>
                )}
              </BaseText>
            </BaseView>
          </BaseView>
        ))}
      </BaseView>
    )
  },
)
